import { Fetch } from '../../shared/types';
import type { ZapierSession } from '@zapier/universal-layout';

export const getSession = async (fetch: Fetch): Promise<ZapierSession> => {
  const data = await fetch<any>('/api/v4/session/');
  return {
    customUserId: data.id,
    isLoggedIn: data.is_logged_in,
    email: data.email,
    hasSeenNotifications: {},
    currentAccountId: data.current_account_id,
  };
};

export default getSession;
